import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import DailyAppointmentDetail from '@/types/table/dailyAppointmentDetail';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface DailyAppointmentDetailData extends DailyAppointmentDetail {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class DailyAppointmentDetailController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<DailyAppointmentDetailData>>(API_CONTEXT + '/app/dailyAppointmentDetail/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<DailyAppointmentDetailData>(API_CONTEXT + '/app/dailyAppointmentDetail/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/dailyAppointmentDetail/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/dailyAppointmentDetail/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/dailyAppointmentDetail/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dailyAppointmentDetail/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dailyAppointmentDetail/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dailyAppointmentDetail/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dailyAppointmentDetail/deleteBatch', params, httpOptions);
  }
}
